import { applyLandingBrand } from "@/lib/siteHosts"

export const credibilityContent = applyLandingBrand({
  eyebrow: "FRACTOLABS RESEARCH LAB • INDUSTRY BENCHMARK #4026",
  h1: "2026 Roofing Industry Speed-to-Lead Index",
  subheadline:
    "A nationwide blind audit measuring real-world response times, customer leakage, and financial gaps across 1,201 active roofing contractors.",
  kpis: [
    { value: "83.1%", label: "Failed to respond within 24 hours" },
    { value: "4h 12m", label: "Industry average response delay" },
    { value: "0.12%", label: "Companies answering in under 60 seconds" },
    { value: "$52,400/mo", label: "Average estimated revenue leakage per contractor" },
  ],
})
